import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '@dixa/lib-shared-habla';
import { HTTPRequestMethod } from 'lib-shared-legacy-types';
import * as React from 'react';
import { v4 as uuid } from 'uuid';
import { FlowNode, flowNodeColor, FlowType, NodeTypeComponent, } from 'fable/flowEditor';
import ActionModal from '../../containers/modals/integration';
import { formatPortsHelper } from '../../helpers/nodePortFormatter';
import { FlowNodeTypes } from '../types';
const portTranslator = (node) => [
    {
        connection: node.payload.nextNodeId || uuid(),
        id: uuid(),
        label: 'arrow',
        type: 'out',
    },
];
const findScopeVariableMatches = (searchString) => {
    const p = RegExp('{{scope:([^}]+)}}', 'gm');
    const matchedString = [];
    if (searchString) {
        let matches;
        while ((matches = p.exec(searchString)) !== null) {
            if (matches && matches[1]) {
                matchedString.push(matches[1]);
            }
        }
    }
    return matchedString;
};
const TRANSLATE_SCOPE_VARIABLES = (node) => {
    const scopeVariables = {
        grants: [],
        needs: [],
    };
    scopeVariables.needs = scopeVariables.needs
        .concat(findScopeVariableMatches(node.payload.url))
        .concat(findScopeVariableMatches(node.payload.body));
    node.payload.variables &&
        node.payload.variables.forEach((variable) => {
            if (variable.id) {
                scopeVariables.grants.push(variable.id);
            }
        });
    return scopeVariables;
};
const createIntegrationNode = (flowType = FlowType.FLOW_TYPE_CALL) => {
    var _a;
    return _a = class IntegrationNode extends NodeTypeComponent() {
            constructor(props) {
                super(props);
                // We have to bind it like this. Using @boundMethod won't work
                this.triggerEdit = this.triggerEdit.bind(this);
            }
            triggerEdit() {
                const { onEdit, node } = this.props;
                onEdit(node, node.nodeType);
            }
            render() {
                const { scopeVars: { grants }, node: { payload: { httpRequestType = HTTPRequestMethod.Get }, }, } = this.props;
                return (_jsx(FlowNode, { color: IntegrationNode.color, icon: IntegrationNode.icon, label: IntegrationNode.label, text: _jsxs(Text.Paragraph, Object.assign({ clamp: 1 }, { children: ["Method ", _jsx("strong", { children: httpRequestType }), !!grants.length && (_jsxs(React.Fragment, { children: [grants.length === 1 ? ', Variable ' : ', Variables ', _jsx("strong", { children: grants.join(', ') })] }))] })), onEdit: this.triggerEdit }));
            }
        },
        _a.icon = 'bolt',
        _a.label = 'Integration',
        _a.helpText = 'Integrate third-party systems or your own API to route conversations based on relevant customer information in Dixa (e.g. previous orders, tracking links, etc.).',
        _a.disabled = false,
        _a.color = flowNodeColor.blue,
        _a.translatePayload = formatPortsHelper(portTranslator),
        _a.translateScopeVariables = TRANSLATE_SCOPE_VARIABLES,
        _a.ActionModal = ActionModal(flowType),
        _a.actionTrigger = { type: FlowNodeTypes.INTEGRATION },
        _a.updateConnection = (node, _port, newConnection) => {
            const payload = Object.assign({}, node.payload);
            payload.nextNodeId = newConnection;
            return Object.assign(Object.assign({}, node), { payload });
        },
        _a;
};
export const IntegrationNodeCall = createIntegrationNode(FlowType.FLOW_TYPE_CALL);
export const IntegrationNodeEmail = createIntegrationNode(FlowType.FLOW_TYPE_EMAIL);
export const IntegrationNodeMessenger = createIntegrationNode(FlowType.FLOW_TYPE_MESSENGER);
